import { render, staticRenderFns } from "./ModgroupModifierItem.vue?vue&type=template&id=3fbbb853&scoped=true"
import script from "./ModgroupModifierItem.vue?vue&type=script&lang=ts"
export * from "./ModgroupModifierItem.vue?vue&type=script&lang=ts"
import style0 from "./ModgroupModifierItem.vue?vue&type=style&index=0&id=3fbbb853&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbbb853",
  null
  
)

export default component.exports